const backToTop = ($el) => {
    if (typeof $el !== 'undefined' && $el != null) {

        const goToTop = () => {
            document.body.scrollIntoView({
                behavior: 'smooth',
            })
        }
        
        $el.addEventListener('click', () => {
            goToTop()
        })
    }
}

export default backToTop
